import { createListenerMiddleware, createSlice } from "@reduxjs/toolkit"
import { useCallback, useEffect, useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { subscribe } from "lib/live_events"

import { monitoringState, useMonitoredState, forHeartbeat } from "../utils"
import { isPlainObject } from "lodash"

const { initialState, actions } = monitoringState()
const reducers = { ...actions }

const slice = createSlice({
  name: 'owner_users',
  initialState, reducers
})

export function useOwnerUsers(ids) {
  const transformedIds = ids.map(id => {
    if (Array.isArray(id))
      return id.join(',')
    if (isPlainObject(id))
      return `${id.owner_id || id.owner},${id.user_id || id.user}`

    return id
  })
  return useMonitoredState('owner_users', slice.actions, ids)
}

export function useOwnerUser(id) {
  const { owner_users, allLoaded: loaded } = useOwnerUsers([id])
  return { owner_user: owner_users[0], loaded }
}

// External event hookup
export function registerListeners(listenerMiddleware, initAction) {
  listenerMiddleware.startListening({
    actionCreator: initAction,
    effect: async (action, { dispatch }) => {
      subscribe('messaging.new_comment', ({owner_id, posted_by: user_id, owner_user}) => {
        const key = `${owner_id},${user_id}`
        const data = { [key]: owner_user }
        dispatch(slice.actions.addData(data))
      })
    },
  });
}

export const heartbeatActions = forHeartbeat(slice.actions)
export default slice.reducer